import React from "react";

function DataAnalttics({ color = "#384BFF", width = 20, height = 22 }) {
  return (
    <svg
      width={width + ""}
      height={height + ""}
      viewBox="0 0 20 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1 9H5V16H1V9ZM8 6H12V19H8V6Z"
        stroke={color}
        stroke-width="1.5"
        stroke-linejoin="round"
      />
      <path
        d="M10 21V19"
        stroke={color}
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M15 5H19V9.5H15V5Z"
        stroke={color}
        stroke-width="1.5"
        stroke-linejoin="round"
      />
      <path
        d="M3 9V4M17 16V9.5M17 5V1"
        stroke={color}
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
}

export default DataAnalttics;
